import { Button, Grid, Popover } from '@mui/material';
import AutoCompleteMultipleSelect from 'common/forms/AutoCompleteMultipleSelect';
import TextField from 'common/forms/TextField';
import { validateMinLength } from 'common/forms/formValidations';
import { EnableInventoryLookup } from 'common/utils';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { filterBulkLabelHistory } from 'store/thunks/workQueueThunks';

const BulkLabelPrintHistoryFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedNdcs, setSelectedNdcs] = useState([]);

  const filter = useSelector(
    ({
      workQueue: {
        bulkLabels: { bulkLabelHistory },
      },
    }) => ({
      ...bulkLabelHistory.filter,
    })
  );

  const handleOpen = (event) => {
    setSelectedNdcs(filter?.ndcs || []);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  useEffect(() => {
    if (isEmpty(filter.ndcs)) {
      setSelectedNdcs([]);
    }
  }, [filter.ndcs]);

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(
      filterBulkLabelHistory({
        filter: {
          ...formData,
          ndcs: EnableInventoryLookup && !isEmpty(selectedNdcs) ? selectedNdcs : undefined,
        },
      })
    );
  };

  const popoverId = anchorEl ? 'WorkQueue-BulkLabel-BulkLabelHistory-Popover' : undefined;

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='User Name'
                      name='pomUserName'
                      id='WorkQueue-BulkLabel-BulkLabelHistory-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  {EnableInventoryLookup && (
                    <Grid item sx={{ py: 0.5 }}>
                      <AutoCompleteMultipleSelect
                        label='NDC'
                        name='ndcs'
                        id='WorkQueue-BulkLabel-BulkLabelHistory-ndcs-input'
                        multiple
                        freeSolo
                        options={[]}
                        formatOption={(value) => value}
                        defaultValue={selectedNdcs}
                        value={selectedNdcs}
                        onChange={(event, newValue) => setSelectedNdcs(newValue)}
                      />
                    </Grid>
                  )}

                  <Grid container justifyContent='flex-end'>
                    <Button variant='contained' type='submit' disabled={invalid}>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default BulkLabelPrintHistoryFilterButton;
